export default {
  project_list: 'Projet',
  P01CREALOGCOL: "Dimensionnement d'une chaufferie",
  project_project_titre: 'Description',
  project_calcul_titre: 'Conception',
  project_result_titre: 'Résultats',
  project_intput_name: 'Nom du projet',
  project_titre_adresse: 'Ajouter une adresse',
  project_titre_avancement: "Stade d'avancement du projet : ",
  project_titre_desc: 'Description du projet',
  project_titre_remarque: 'Remarque(s)',
  project_status_aps: 'APS',
  project_status_apd: 'APD',
  project_status_dce: 'DCE',
  project_status_permis: 'PERMIS',
  project_status_appoffre: "APPEL D'OFFRE",
  project_status_execution: 'EXECUTION',
  project_status_negociation: 'NEGOCIATION',
  project_status_sav: 'SAV',

  PCUSTOM: 'Projet personnalisé'
}
